<template>
    <div v-if="filterDataSource">
        <FilterPanel
            :dataSource="filterDataSource"
            v-bind:status.sync="category"
            v-bind:substatus.sync="status"
        >
            <ExtendedFilterPanel
                v-if="category == 'ChancellaryIncoming' && $helpers.isExtendedFilterPanelVisible(incomingOnRegExtendedFilter)"
                v-bind:value.sync="incomingOnRegExtendedFilter"
            />

            <ExtendedFilterPanel
                v-if="category == 'ChancellaryOutgoing' && $helpers.isExtendedFilterPanelVisible(outgoingOnRegExtendedFilter)"
                v-bind:value.sync="outgoingOnRegExtendedFilter"
            />

            <ExtendedFilterPanel
                v-if="category == 'ChancellaryInner' && $helpers.isExtendedFilterPanelVisible(innerOnRegExtendedFilter)"
                v-bind:value.sync="innerOnRegExtendedFilter"
            />
        </FilterPanel>

        <component
            :is="category"
            :search="search"
            :status="status"
            ref="currentOnRegisterComponent"
        />

        <IncomingExFilterDlg
            v-if="category == 'ChancellaryIncoming'"
            v-model="incomingOnRegExtendedFilter"
            ref="IncomingExFilterDlgRef"
        />

        <OutgoingsExFilterDlg
            v-if="category == 'ChancellaryOutgoing'"
            v-model="outgoingOnRegExtendedFilter"
            ref="OutgoingExFilterDlgRef"
        />

        <InnersExFilterDlg
            v-if="category == 'ChancellaryInner'"
            v-model="innerOnRegExtendedFilter"
            ref="InnersExFilterDlgRef"
        />

    </div>
</template>


<script>
import { httpAPI } from "@/api/httpAPI";
import ChancellaryIncoming from '@/views/chancellery/lists/Incomings.vue';
import ChancellaryOutgoing from '@/views/chancellery/lists/Outgoings.vue';
import ChancellaryInner from '@/views/chancellery/lists/Inners.vue';
import CorrespondenceChancelleryResolutions from '@/views/chancellery/lists/Resolutions.vue';
import FilterPanel from '@/components/documents/FilterPanel.vue';
import ExtendedFilterPanel from '@/components/documents/ExtendedFilterPanel.vue';
import IncomingExFilterDlg from '@/components/documents/dialogs/extended-filters/chancellery/incoming.vue';
import OutgoingsExFilterDlg from '@/components/documents/dialogs/extended-filters/chancellery/outgoing.vue';
import InnersExFilterDlg from '@/components/documents/dialogs/extended-filters/chancellery/inner.vue';

export default {
    props: {
        search: {
            type: String,
            default: ""
        }
    },
    components:{
        ChancellaryIncoming,
        ChancellaryOutgoing,
        ChancellaryInner,
        CorrespondenceChancelleryResolutions,
        FilterPanel,
        ExtendedFilterPanel,
        IncomingExFilterDlg,
        OutgoingsExFilterDlg,
        InnersExFilterDlg
    },
    data() {
        return {
            filterDataSource: {
                Filter: {
                    Title: "Категория",
                    Default: "ChancellaryIncoming",
                    Items: [
                        {
                            Name: "Обработка_входящих",
                            Value: "ChancellaryIncoming",
                            Count: -1,
                            Requires: [ "ChancelleryIncomingDocumentsList" ],
                            HasItems: true,
                            Items: {
                                Title: "Статус",
                                Default: "-10",
                                Items: [
                                    { Name: "На_регистрации", Value: "-10", Count: -1 },
                                    { Name: "Без_вложений", Value: "-400", Count: -1 },
                                    { Name: "Отклоненные", Value: "3", Count: -1 },
                                    { Name: "Удаленные", Value: "-100", Count: -1 },
                                ]
                            }
                        },
                        {
                            Name: "Регистрация_исходящих",
                            Value: "ChancellaryOutgoing",
                            Count: -1,
                            Requires: [ "ChancelleryOutcomingDocumentsList" ],
                            HasItems: true,
                            Items: {
                                Title: "Статус",
                                Default: "-10",
                                Items: [
                                    { Name: "На_регистрации", Value: "-10", Count: -1 },
                                    { Name: "Отклоненные", Value: "3", Count: -1 },
                                    { Name: "Удаленные", Value: "-100", Count: -1 },
                                ]
                            }
                        },
                        {
                            Name: "Регистрация_внутренних",
                            Value: "ChancellaryInner",
                            Count: -1,
                            Requires: [ "ChancelleryInternalDocumentsList" ],
                            HasItems: true,
                            Items: {
                                Title: "Статус",
                                Default: "-10",
                                Items: [
                                    { Name: "На_регистрации", Value: "-10", Count: -1 },
                                    { Name: "Отклоненные", Value: "3", Count: -1 },
                                    { Name: "Удаленные", Value: "-100", Count: -1 },
                                ]
                            }
                        },
                        {
                            Name: "Отправка_резолюций",
                            Value: "CorrespondenceChancelleryResolutions",
                            Count: -1,
                            Requires: [ "CanSignChancellery" ],
                            HasItems: false
                        }
                    ]
                }
            },
        }
    },
    computed: {
        category: {
            get: function() {
                return this.$store.getters['correspondence/inWork/onRegister/getCategory'];
            },
            set: function(v) {
                this.$store.commit('correspondence/inWork/onRegister/SET_CATEGORY', v );
            },
        },
        status: {
            get: function() {
                return this.$store.getters['correspondence/inWork/onRegister/getStatus'];
            },
            set: function(v) {
                this.$store.commit('correspondence/inWork/onRegister/SET_STATUS', v );
            },
        },
        incomingOnRegExtendedFilter: {
            get: function() {
                return this.$store.getters['chancellery/lists/incomings/getExtendedFilter']
            },
            set: function(v) {
                if (typeof this.$refs.currentOnRegisterComponent?.resetPage === "function")
                    this.$refs.currentOnRegisterComponent.resetPage();

                if (v)
                    this.$store.commit('chancellery/lists/incomings/SET_EXTENDED_FILTER', v );
            }
        },
        outgoingOnRegExtendedFilter: {
            get: function() {
                return this.$store.getters['chancellery/lists/outgoings/getExtendedFilter']
            },
            set: function(v) {
                if (typeof this.$refs.currentOnRegisterComponent?.resetPage === "function")
                    this.$refs.currentOnRegisterComponent.resetPage();

                if (v)
                    this.$store.commit('chancellery/lists/outgoings/SET_EXTENDED_FILTER', v );
            }
        },
        innerOnRegExtendedFilter: {
            get: function() {
                return this.$store.getters['chancellery/lists/inners/getExtendedFilter']
            },
            set: function(v) {
                console.log(v);
                if (typeof this.$refs.currentComponent?.resetPage === "function")
                    this.$refs.currentComponent.resetPage();

                if (v)
                    this.$store.commit('chancellery/lists/inners/SET_EXTENDED_FILTER', v );
            }
        },
    },
    methods: {
        async loadFilters() {
            let filterResponse = await httpAPI({
                url: `/api/chancellary/filter?collection=${this.category}`,
                method: 'GET'
            });
            if (filterResponse?.data?.Payload){
                let newItems = filterResponse.data.Payload.Filter?.Items?.find(f => f.Value == this.category)?.Items?.Items;
                let categoryItems = this.filterDataSource.Filter.Items.find(f => f.Value == this.category)?.Items?.Items;
                if (categoryItems && newItems){
                    newItems.forEach(newItem => {
                        let oldItem = categoryItems.find(item => item.Value == newItem.Value);
                        if (oldItem)
                            oldItem.Count = newItem.Count;
                    });
                }
            }
        },
        async getData(isrefresh = false) {
            this.loadFilters();
            if (this.$refs.currentOnRegisterComponent)
                this.$refs.currentOnRegisterComponent.getData(isrefresh);
            this.$eventBus.$emit('update_correspondents_counters');
        },
        async onFilterClick() {
            try
            {
                switch (this.category){
                    case "ChancellaryIncoming":
                        await this.$refs.IncomingExFilterDlgRef.open();
                        break;
                    case "ChancellaryOutgoing":
                        await this.$refs.OutgoingExFilterDlgRef.open();
                        break;
                    case "ChancellaryInner":
                        await this.$refs.InnersExFilterDlgRef.open();
                        break;
                }
            }
            catch (ex)
            {
                if (ex.isCancelled === true)
                    console.warn("Подготовка расширенного фильтра отменена");
            }
        },
    },
    watch: {
        category: {
            handler() {
                this.getData()
            },
            deep: true,
        },
    },
    async created() {
        await this.getData();
    }
}

</script>